import { FC, MouseEvent } from 'react';

import { useAppRouter } from '@contexts/router';
import { useClearDispatch } from '@contexts/auth/AuthContext';
import { removeBasketDetailsOnLocalStorage } from '@utils/removeBasketDetailsOnLocalStorage';

import { StyledLink } from './styled';

interface IUserMenuLink {
  label: string;
  href: string;
  onClose?: () => void;
}

const UserMenuLink: FC<IUserMenuLink> = ({ label, href, onClose }) => {
  const { push } = useAppRouter();

  const clearUserInformation = useClearDispatch();

  const handleClick = async (e: MouseEvent<HTMLAnchorElement>) => {
    if (href === '/logout') {
      e.preventDefault();
      onClose?.();

      /**
       * Clear user information from context
       */
      clearUserInformation();

      /**
       * Remove basket details from local storage when user logs out
       */
      removeBasketDetailsOnLocalStorage();

      /**
       * Redirect to home page
       */
      push('/');
      return false;
    }

    onClose?.();
    return true;
  };

  return (
    <StyledLink prefetch={false} href={href} onClick={handleClick}>
      {label}
    </StyledLink>
  );
};

export default UserMenuLink;
